import { render, staticRenderFns } from "./MensagemConfirmacao.vue?vue&type=template&id=a4707d34&scoped=true"
import script from "./MensagemConfirmacao.vue?vue&type=script&lang=js"
export * from "./MensagemConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./MensagemConfirmacao.vue?vue&type=style&index=0&id=a4707d34&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4707d34",
  null
  
)

export default component.exports